// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__J4lDq","header":"MessagesList_header__3HgGv","chat":"MessagesList_chat__1ob96"};